import { ordenarArray, mostrarIdioma, parsePrecios, pointInPolygon, redondeo } from '@/utils/funciones_auxiliares.js';
var _ = require('lodash');

export default {
	getDistanciasRestaurantes(state) {
		return state.distanciasRestaurantes;
	},
	arrayZonasReparto(state, getters, rootState) {
		let r = [];
		if (rootState.pedido.listadoRestaurantes) {
			rootState.pedido.listadoRestaurantes.forEach(e => {
				if (e.zonasReparto)
					r = [...r, ...e.zonasReparto];
			});
		}

		return r;
	},
	categoriasFiltradas(state) {
		let cats = state.categorias;
		let res = [];
		cats.forEach(c => {
			let aux = {
				nombre: mostrarIdioma(c.nombre),
				descripcion: mostrarIdioma(c.descripcion),
				orden: c.orden,
				id: c.id,
				productos: []
			};
			res.push(aux);
		});
		return res.sort(ordenarArray);
	},
	//devuelve todos los restaurantes con los parámetros de su negocio asociado
	filtradoRestauranteNegocios(state, getters, rootState) {
		var r = state.listadoRestaurantes;
		var n = state.listadoNegocios;
		var negocioPropio = rootState.propio.negocioPropioObj;
		var res = [];
		const index = rootState.direcciones.modoEligiendo == "domicilio" ? 0 : 1;

		if (negocioPropio) {
			res = r;
			console.log(r.length);
			res = res.sort((a, b) => {
				return a.distancia - b.distancia;
				/* console.log(a.horariosComputados);
				console.log(b.horariosComputados);
				console.log(index);
				if (a.horariosComputados[index] && b.horariosComputados[index]) {
					return a.distancia - b.distancia;
				} else if (a.horariosComputados[index]) { //b está cerrado
					return true;
				} else {
					return false;
				} */
			})
			negocioPropio.direccionNegocio = negocioPropio.direccion;
			delete negocioPropio.direccion;
			res = res.map((e) =>
				e = {
					idRest: e.id,
					nombreRest: e.nombre,
					...e,
					...negocioPropio
				})
			console.log(res);
		} else {
			if (Array.isArray(r) && Array.isArray(n)) {
				r.forEach((rAux) => {
					let found = n.find((e) => { return e.id == rAux.negocio })
					if (found) {
						let fAdd = { ...rAux, ...found }
						res.push(fAdd);
					}
				})
				res = res.sort((a, b) => {
					if (a.horariosComputados[index] && b.horariosComputados[index]) {
						return a.distancia - b.distancia;
					} else if (a.horariosComputados[index]) { //b está cerrado
						return true;
					} else {
						return false;
					}
				})
			}
		}
		return res;
	},

	filtradoProductosRestaurante(state, getters, rootState, rootGetters) {
		let modoFuncionamiento = rootState.config.modoFuncionamiento;
		let categories = getters.categoriasFiltradas;
		let prds = state.allProductos;
		let prdNeo = (state.allProductosBartolome) ? state.allProductosBartolome : [];
		const impuestos = state.impuestos;
		const descuentos = state.descuentos;
		const prodsAsociados = (rootState.pedido.restauranteObjPedido) ? rootState.pedido.restauranteObjPedido.productosAsociados : [];//(rootGetters['pedido/restaurantePedidoObj']) ? rootGetters['pedido/restaurantePedidoObj'].productosAsociados : [];

		// let devolver = [];
		let cGlobal = state.caracteristicas != null ? state.caracteristicas : [];

		if (Array.isArray(prodsAsociados)) {
			prds.forEach(p => {
				var found = prodsAsociados.find((e) => e.id == p.id)
				if (found) {
					found.opcionesAsociadas = found.opciones;
					p.opcionesPrevias = p.opciones;
					var prodIncluir = { ...found, ...p };
					let foundImp = impuestos.find((i) => i.id == prodIncluir.impuesto)
					if (foundImp) {
						prodIncluir.impPorcentaje = parseFloat(foundImp.impuesto)
					}

					/************************** INICIO Bloque de descuentos **************************
								obtenidos por ID, tipo y jerarquía
					**************														*************/

					let productoDesc = null;
					let categoriaDesc = null;
					let restauranteDesc = null;
					let negocioDesc = 0;
					descuentos.forEach((d) => {
						switch (d.tipo) {
							case 'producto':
								if (d.productos.includes(prodIncluir.id)) {
									productoDesc = d.porcentaje;
									console.log(prodIncluir);
								}
								break;
							case 'categoria':
								if (d.categorias.includes(prodIncluir.categoria)) {
									categoriaDesc = d.porcentaje;
								}
								break;
							case 'restaurante':
								if (d.restaurantes.includes(rootState.pedido.restauranteObjPedido.id)) {
									restauranteDesc = d.porcentaje;
								}
								break;
							case 'negocio':
								negocioDesc = d.porcentaje;
								break;
						}
					})

					if (productoDesc != null) {
						prodIncluir.descuentoTexto = productoDesc * 100 + ' %';
						prodIncluir.descuentoPorcentaje = productoDesc;
					} else if (categoriaDesc != null) {
						prodIncluir.descuentoTexto = categoriaDesc * 100 + ' %';
						prodIncluir.descuentoPorcentaje = categoriaDesc;
					} else if (restauranteDesc != null) {
						prodIncluir.descuentoTexto = restauranteDesc * 100 + ' %';
						prodIncluir.descuentoPorcentaje = restauranteDesc;
					} else {
						prodIncluir.descuentoTexto = negocioDesc * 100 + ' %';
						prodIncluir.descuentoPorcentaje = negocioDesc;
					}

					/**************************** FIN Bloque de descuentos ****************************/


					const opsAsoc = found.opciones;
					var prodsFinales = [];

					p.opciones.forEach((pPrevio) => {
						let aux = pPrevio;
						var opsAsocPaneles = [];

						pPrevio.opciones.forEach((opPrevio) => {
							var foundOpAsoc = opsAsoc.find((e) => e.id == opPrevio.id);

							if (foundOpAsoc && foundOpAsoc.asociado) {
								var auxOpPanel = opPrevio;
								auxOpPanel.precioRest = foundOpAsoc.precio;
								auxOpPanel.precioCobrar = (prodIncluir.descuentoPorcentaje) ? redondeo(auxOpPanel.precioRest * (1 - prodIncluir.descuentoPorcentaje)) : redondeo(auxOpPanel.precioRest);
								opsAsocPaneles.push(auxOpPanel);
							}
						})

						aux.opciones = opsAsocPaneles;
						prodsFinales.push(aux);
					})


					prodIncluir.opciones = prodsFinales;
					p = prodIncluir; //para aprovechar el código antiguo

					let aux = JSON.parse(JSON.stringify(p));

					let cs = p.caractSeleccionadas;
					if (!cs)
						cs = [];
					let caracts = [];

					cs.forEach(c => {
						let find_c = cGlobal.find((e) => e.id == c)
						if (find_c) {
							let find_grupo = caracts.find((e) => e.grupo == find_c.grupo)
							if (find_grupo) {
								find_grupo.caracteristicas.push({
									nombre: mostrarIdioma(find_c.nombre),
									id: find_c.id,
									img: find_c.imagen
								});
							} else {
								let aux = {
									grupo: find_c.grupo,
									caracteristicas: [{
										nombre: mostrarIdioma(find_c.nombre),
										id: find_c.id,
										img: find_c.imagen
									}]
								}
								caracts.push(aux);
							}
						}
					});
					aux.caractSeleccionadas = caracts;
					var auxPrecioPreDescuento = aux.precioRest ? aux.precioRest : 0;
					aux.precioCobrar = (aux.descuentoPorcentaje) ? redondeo(auxPrecioPreDescuento * (1 - aux.descuentoPorcentaje)) : redondeo(auxPrecioPreDescuento);
					aux.nombre = mostrarIdioma(p.nombre);
					aux.descripcion = mostrarIdioma(p.descripcion);

					//aux = parsePrecios(aux);
					// Comprueba que la categoría exista y el producto no esté ya en ella
					var catFound = categories.find((e) => e.id == aux.categoria);
					var prodFound = catFound.productos.find((e) => e.id == aux.id);
					if (catFound && !prodFound) {
						catFound.productos.push(aux);
					}

				}
			});
		}
		categories.map(cats => {
			cats.productos = cats.productos.sort((a, b) => (a.orden > b.orden) ? 1 : ((b.orden > a.orden) ? -1 : 0))
			return cats
		})
		return categories;
	},
	restauranteAbierto(state, getters, rootState) {
		console.log(rootState.pedido.restauranteObjPedido)
		let index = rootState.pedido.activePedido.forma_envio == "domicilio" ? 0 : 1;
		return (rootState.pedido.restauranteObjPedido.horariosComputados) ? rootState.pedido.restauranteObjPedido.horariosComputados[index] : false;
	},
	listadoRestauranteFormContacto(state, getters, rootState) {
		if (rootState.app.modoGeneral == 'propio') {
			return state.listadoRestaurantes.filter(e => (e.confGeneral) && (e.confGeneral.aceptaFormContacto)).map(e => {
				return {
					value: e.id,
					text: e.nombre
				}
			});
		}
	}
}